import API from './axios.js'

// baseURL
let API_ADDRESS = process.env.NODE_ENV == "production" ? Global.BASEURL : "/api";



/*****************************登录相关接口**************************** */
// 账号密码登录
export function login(params) {
  return API.fetchPost(API_ADDRESS + "/static/public/auth/user", params)
}


// PC单点登录
export function casLogin(params) {
  if (params != undefined) {
    Object.assign(params, { loginType: 'PC' })
  }
  return API.fetchPost(API_ADDRESS + `/static/public/auth/cas/${params.token}`, params)
}


// 获取登录验证码
export function generateCaptcha(username) {
  return API.fetchPost(API_ADDRESS + `/static/public/cg/generateCaptcha/${username}`, {})
}

// 获取通知
export function getNotice(username) {
  return API.fetchPost(API_ADDRESS + `/static/public/cg/generateCaptcha/${username}`, {})
}

// 获取首页的座位信息
export function getAvailSeats(username) {
  return API.fetchPost(API_ADDRESS + `/static/public/cg/generateCaptcha/${username}`, {})
}

// 获取系统配置信息
export function getSysSet() {
  return API.fetchPost(API_ADDRESS + `/static/public/cg/getSysSet/PC`, {})
}

// 获取个人激活码
export function setActivationCode() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/getActCode`, {})
}

// 获取签到二维码
export function getQrSignJy() {
  return API.fetchPost(API_ADDRESS + `/static/public/cg/getSysSet`, {})
}

// 签到
export function checkInByQr(data) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/checkIn?qrMd5=PC`, {})
}

// 用户解绑
export function unbindUser() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/unbind`, {})
}

// 解绑
export function unbindCAS() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/logout`, {})
}


/*********************************个人相关接口*********************************** */
// 获取个人信息
export function getUserInfo() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/getUserInfo`, {})
}

// 获取正在使用中的预约
export function getUsingResverations() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/currentUseMake`, {})
}


// 获取最近预约记录
export function getUserLastResveration() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/lastMake`, {})
}

// 获取个人违约记录
export function getUserDefault(params) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/breach/${params.page}/${params.pageSize}`, {})
}

// 获取个人历史记录
export function getUserHistory(page, pageSize) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/history/${page}/${pageSize}`, {})
}

// 获取预约变更记录
export function getMakeLifeList(makeId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/makeLife/${makeId}`, {})
}

// 获取当前用户有效的预约记录
export function currentUseMake() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/currentUseMake`, {})
}

// 取消预约
export function cancelOrder(makeId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/cancel/${makeId}`, {})
}

// 续约
export function extendMake(endMinute, qrMd5) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/extendMake/${endMinute}?qrMd5=${qrMd5}`, {})
}

// 变更记录
export function makeLife(makeId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/makeLife/${makeId}`, {})
}

//获取JSSDK配置信息
export function getJsSdk() {
  let vueConfig = JSON.parse(sessionStorageProxy.getItem('vueConfig'))
  var url = window.location.href.split('#')[0];
  var corpId = vueConfig.CORPID
  var urlData = `/static/frontApi/user/getJsSdkInfo?url=${url}`;
  urlData = (urlData + (corpId != '' ? `&corpType=${corpId}` : ''))
  return API.fetchPost(API_ADDRESS + urlData, {})
}

/*****************************预约和房间相关接口****************************** */

// 获取所有的场馆以及场馆下面的信息
export function getBuildingFloorDate() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/buildingFloorDate`, {})
}

// 按照最小时长获取空间
export function findRoomDuration(param, buildId, makeDate) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/findRoomDuration/${buildId}/${makeDate}`, param)
}

// 按照固定时段获取空间
export function findRoomSlice(params, buildId, makeDate) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/findRoomSlice/${buildId}/${makeDate}`, params)
}

// 获取座位空闲时间轴
export function getTimeLine(seatId, makeDate) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/getTimeLine/${seatId}/${makeDate}`, {})
}

// 获取座位布局图
export function getSeatLayout(param) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/querySeatLayout/${param.roomId}/${param.updV}`, {})
}
//手动结束
export function stopSeat() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/stop`, {})
}

//暂离
export function awaySeat() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/leave`, {})
}
// 按固定时段获取空闲座位
export function freeSeatIdsSlice(roomId, makeDate, param) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/freeSeatIdsSlice/${roomId}/${makeDate}`, param)
}

// 按最小时长获取空闲座位
export function freeSeatIdsDuration(roomId, makeDate, param) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/freeSeatIdsDuration/${roomId}/${makeDate}`, param)
}

// 按固定时段获取起止时间
export function getMakeSlices(seatId, makeDate) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/getMakeSlices/${seatId}/${makeDate}`, {})
}

// 按最小时长获取开始时间集合
export function getStartTimes(seatId, makeDate) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/getStartTimes/${seatId}/${makeDate}`, {})
}

// 根据开始时间获取结束时间集合
export function getEndTimes(seatId, makeDate, startMinute) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/getEndTimes/${seatId}/${makeDate}/${startMinute}`, {})
}

// 开始预约
export function freeBook(param) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/freeBook/${param.seatId}/${param.makeDate}/${param.startMinute}/${param.endMinute}?capToken=${param.capToken}`, {})
}

// 随机排座
export function randomSeat(param) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/quickBook/${param.roomId}/${param.endMinute}`, { loading: true })
}

// 获取可预约的时间片段
export function continuedSeatTime() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/extendTime`, {})
}

// 举报监督
export function superviseLeave(seatId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/make/superviseLeave/${seatId}`, {})
}

// 查看当前座位的今日预约记录
export function lastMakeBySeatId(seatId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/lastMakeBySeatId/${seatId}`, {})
}

// 查看当前座位的历史预约记录
export function historyBySeatId(seatId, page, pageSize) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/historyBySeatId/${page}/${pageSize}/${seatId}`, {})
}

// 查看当前座位的历史预约记录
export function breachBySeatId(seatId, page, pageSize) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/breachBySeatId/${page}/${pageSize}/${seatId}`, {})
}

// 强制签到
export function cancelAdmin(makeId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/admin/cancel/${makeId}`, {})
}

// 强制取消
export function checkInAdmin(makeId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/admin/checkIn/${makeId}`, {})
}

// 强制暂离
export function leaveAdmin(makeId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/admin/leave/${makeId}`, {})
}

// 强制取消
export function stopAdmin(makeId) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/admin/stop/${makeId}`, {})
}


// 统计接口
export function appointmentDataStatistics() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/admin/query/appointmentDataStatistics`, {})
}

// 统计接口
export function getSeatInfo(roomUuidSeatLabel) {
  return API.fetchPost(API_ADDRESS + `/static/public/cg/findSeat/${roomUuidSeatLabel}`, {})
}

// 获取结束时间集合
export function getEndTimesFilter(buildId, startMinute) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/getEndTimes2/${buildId}/${startMinute}`, {})
}

// 是否高峰期
export function checkHigh() {
  return API.fetchPost(API_ADDRESS + `/static/cap/cg/checkHigh`, {})
}

// 门禁记录
export function fetchUserDoorLog(doorDate) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/user/doorLog/${doorDate}`, {})
}

// 获取常用座位
export function findCommonSeat() {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/findCommonSeat`, {})
}

// 楼层布局图
export function queryMarkLayout(params) {
  return API.fetchPost(API_ADDRESS + `/static/frontApi/res/queryMarkLayout/${params.id}/${params.updV}`)
}



// WEBPACK FOOTER //
// ./src/api/index.js